<template>
  <div :class="'detail-panel__jakartowns'">
    <div :id="'detail-panel__jakartowns__app'" />
    <div :class="'detail-panel__jakartowns__loader'">
      <div :class="'detail-panel__jakartowns__loader__logo'" />
    </div>
    <div :class="'detail-panel__jakartowns__redirect'" @click="redirect">
      <icon-redirect
        :class="'detail-panel__jakartowns__redirect__icon'"
        :color="whiteColor"
      />
      <div :class="'detail-panel__jakartowns__redirect__title'">
        <div>Jakartowns</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import IconRedirect from '@/components/icons/IconRedirect.vue'
import useDetailPanelStore from '@/stores/detailPanel'
const detailPanelStore = useDetailPanelStore()
const whiteColor = getComputedStyle(document.documentElement).getPropertyValue(
  '--white',
)
const {
  selectedAsset,
  selectedAssetPosition,
  observerPosition,
  rotation,
  tilt,
  fov,
  availableImages,
  currentImageId,
} = storeToRefs(detailPanelStore)

const redirect = () => {
  const { lat, lng } = selectedAssetPosition.value
  window.open(
    `https://maps.jakarto.com?lat=${lat}&lng=${lng}&pan=${rotation.value}&tilt=${tilt.value}&fov=${fov.value}`,
  )
}
</script>

<style scoped>
@keyframes jakman-animate {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1);
  }
}

@keyframes jakman-animate-2 {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.3);
  }
}
.detail-panel__jakartowns {
  width: 100%;
  height: 800px;
  /* max-height: 40vh; */
  border-radius: 12px 12px 0px 0px;

  display: flex;
  justify-content: center;

  overflow: hidden;

  filter: drop-shadow(var(--panel-shadow));
}

:deep(#detail-panel__jakartowns__app) {
  width: 100%;

  cursor: move;
}

.detail-panel__jakartowns__loader {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: var(--jakartowns-background);
}

.detail-panel__jakartowns__loader__logo {
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;

  background-color: var(--white);

  animation: jakman-animate 550ms infinite alternate;
}

.detail-panel__jakartowns__loader__logo::after {
  content: '';

  position: absolute;
  left: -13px;
  top: -13px;
  width: 24px;
  height: 24px;
  border: 8px solid var(--white--hovered);
  border-radius: 50%;

  animation: jakman-animate-2 550ms infinite alternate;
}
.detail-panel__jakartowns__redirect {
  position: absolute;
  bottom: 10px;
  z-index: 100;
  width: 145px;
  height: 35px;
  border-radius: 20px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  background-color: var(--primary);
  cursor: pointer;

  filter: drop-shadow(var(--panel-shadow));
}

.detail-panel__jakartowns__redirect__icon {
  width: 14px;
  height: 14px;
  margin: -2px 12px 0px;
}

.detail-panel__jakartowns__redirect__title {
  margin: 0px 12px 0px 0px;

  font-family: var(--font-family);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  color: var(--white);
}

.detail-panel__jakartowns__redirect__date {
  margin: 0px 0px 0px 0px;
  font-family: var(--font-family);
  font-size: 8px;
  color: var(--light-grey);
}
</style>
